import dayjs from 'dayjs'

import { MinBookingNights } from '../config'

interface DateRange {
  startDate?: string
  endDate?: string
}

const normalizeDate = (date?: string): string | null => {
  if (!date) return null

  const [year, month, day] = date.split('/').join('-').split('-')
  const normalizedDate = `${year}-${month?.padStart(2, '0')}-${day?.padStart(2, '0')}`
  const parsedDate = dayjs(normalizedDate)

  return parsedDate.isValid() &&
    parsedDate.format('YYYY-MM-DD') === normalizedDate
    ? normalizedDate
    : null
}

export const isAvailableDateRange = (
  { startDate, endDate }: DateRange,
  availableDates?: string[],
): boolean => {
  const normalizedStartDate = normalizeDate(startDate)

  if (!normalizedStartDate) return false

  const normalizedAvailableDates = new Set(
    availableDates?.map(normalizeDate).filter(Boolean),
  )

  if (
    normalizedAvailableDates.size &&
    !normalizedAvailableDates.has(normalizedStartDate)
  ) {
    return false
  }

  if (!endDate) return true

  const normalizedEndDate = normalizeDate(endDate)

  if (!normalizedEndDate) return false

  const start = dayjs(normalizedStartDate)
  const end = dayjs(normalizedEndDate)

  if (end.diff(start, 'day') < MinBookingNights) return false
  if (!normalizedAvailableDates.size) return true

  for (let date = start; !date.isAfter(end, 'day'); date = date.add(1, 'day')) {
    if (!normalizedAvailableDates.has(date.format('YYYY-MM-DD'))) return false
  }

  return true
}
